function setupClickEvents() {
    $(document).on('click',
        '.toggleDetails',
        function(data, handler) {
            if ($(data.target).parent('.fatSelect').length == 0) {
                var $thisRow = $(this).closest('tr');
                var $detailRow = $thisRow.next('tr');
                $thisRow.add($detailRow).toggleClass('show');
                var visible = $thisRow.hasClass('show');
                var barBorrow = $detailRow.find('.bar-borrow');
                $(barBorrow).width(visible ? $(barBorrow).attr('data-width') : '0%');
            }
        });

    $(document).on('click',
        '.coverToggle',
        function() {
            show = $(this).hasClass('active');
            $('.toggleDetails, .rowDetails').toggleClass('show', show);
            $('.detailTable').toggleClass('showAll', show);

            if (show) {
                $('.bar-borrow').each(function() {
                    $(this).width($(this).attr('data-width'));
                });
            }
        });
}

function ajaxOnSuccessLazyLoadCover() {
    LazyLoadCovers();

    $('.lazyLoadCover').each(function () {
        $(this).on('load',
            function () {
                if (this.naturalWidth <= 1) {
                    var grp = $(this).attr('data-src-mediagroup');
                    $(this).on('error',
                            function () {
                                $(this).attr('src', rootUrl + "/images/mediagrp/leer.png");
                                $(this).parent().attr('src', rootUrl + "/images/mediagrp/leer.png");
                                $(this).parent().attr('data-lightbox', rootUrl + "/images/mediagrp/leer.png");
                                $(this).parent().attr('href', rootUrl + "/images/mediagrp/leer.png");
                            })
                        .attr('src', grp);
                }
            });
        $(this).attr('src', $(this).attr('data-src'));
    });
}

function loadList(userServiceUrl, isMobile, sidePanelRightClientId) {
    $('#diviBibResultList').spin({
        lines: 12,
        length: 9,
        width: 6,
        radius: 12,
        speed: 0.88,
        tail: 100,
        color: '#4C628C',
        top: '50px'
    });

    var action = 'action=divibib';
    if (isMobile === true) {
        action = action + '&mobile=1';
    }

    $.ajax({
        type: "POST",
        async: true,
        url: userServiceUrl,
        data: action,
        dataType: "html",
        success: function (data) {
            $('#diviBibResultList').spin(false);

            if (isMobile === true) {
                $(data).find("#sidebarDetails").children().detach().appendTo(sidePanelRightClientId);
            }

            $('#diviBibResultList').html(data);

            ajaxOnSuccessLazyLoadCover();
        }
    });
}
